import type { FacilityMetaContact } from './tier2submit-export.ts';

/** The first/last split written to Tier2 Submit. Business names export with an empty first name. */
export function contactNameParts(contact: Pick<FacilityMetaContact, 'name' | 'nameIsBusiness'>): {
  firstName: string;
  lastName: string;
} {
  const name = contact.name.trim();
  if (contact.nameIsBusiness) return { firstName: '', lastName: name };
  const parts = name.split(/\s+/).filter(Boolean);
  const lastName = parts.pop() ?? '';
  return { firstName: parts.join(' '), lastName };
}

export function contactHasFirstAndLastName(contact: Pick<FacilityMetaContact, 'name' | 'nameIsBusiness'>): boolean {
  const { firstName, lastName } = contactNameParts(contact);
  return Boolean(firstName && lastName);
}
